import { useTranslation } from 'react-i18next';

import { linguaFormato } from '@/lib/fmt';

/**
 * La lingua con cui scrivere date e numeri in un componente (`lib/fmt.ts`).
 * Passa da `useTranslation`, che si iscrive al cambio di lingua: il componente si ridisegna quando
 * l'utente cambia lingua nelle Preferenze. Se la `useTranslation` di un test non da' `i18n`, vale la
 * lingua globale (`linguaFormato(undefined)`).
 */
export function useLinguaFormato(): string {
  const { i18n } = useTranslation();
  return linguaFormato(i18n);
}
